import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Get My Saved Products
export const getMySavedProducts = async (params = {}) => {
  const response = await api.get("/user/my/saved-products", {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return response.data;
};
// ✅ Save product (Add to favorites)
export const saveProduct = async (productId) => {
  const id =
    typeof productId === "object"
      ? (productId?.product_id ?? productId?.product?.id ?? productId?.id)
      : productId;

  if (!id) throw new Error("productId is required");

  const response = await api.get(`/user/save/product/${id}`, {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
// ✅ Remove saved product (Remove from favorites)
export const removeSavedProduct = async (productId) => {
  // ✅ حماية لو حد بعت object بالغلط
  const id =
    typeof productId === "object"
      ? productId?.product_id ?? productId?.product?.id ?? productId?.id
      : productId;

  if (!id) throw new Error("productId is required");

  const response = await api.get(`/user/remove/saved/product/${id}`, {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
// ✅ Create Review
export const createReview = async ({ product_id, rating, review }) => {
  if (!product_id) throw new Error("product_id is required");
  if (!rating) throw new Error("rating is required");

  const formData = new FormData();
  formData.append("product_id", String(product_id));
  formData.append("rating", String(rating));
  formData.append("review", String(review || ""));

  const response = await api.post("/user/create/review", formData, {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
      // ❌ متحطش Content-Type مع FormData
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
// ✅ Delete Review (حذف مراجعة)
export const deleteReview = async (reviewId, params = {}) => {
  if (!reviewId) throw new Error("reviewId is required");

  const res = await api.get(`/user/delete/review/${reviewId}`, {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    // لو api instance عندك بيضيف api_password تلقائيًا، تقدر تشيل السطر ده
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return res.data;
};
// ✅ Update Review
export const updateReview = async (
  reviewId,
  {
    rating, // number 1 - 5
    review, // string
  } = {},
  params = {}
) => {
  if (!reviewId) throw new Error("reviewId is required");

  const formData = new FormData();

  if (rating !== undefined && rating !== null) {
    formData.append("rating", String(rating));
  }

  if (review !== undefined && review !== null) {
    formData.append("review", String(review));
  }

  const res = await api.post(
    `/user/update/review/${reviewId}`,
    formData,
    {
      headers: {
        Accept: "application/json",
        // ❗ مهم: متحطش Content-Type مع FormData
        ...getAuthHeaders(),
      },
      params: {
        api_password: "EcommercApp@2026_$",
        ...params,
      },
    }
  );

  return res.data;
};
// ✅ Get My Reviews (مراجعاتي)
export const getMyReviews = async (params = {}) => {
  const res = await api.get("/user/my/reviews", {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    // لو api instance عندك بيضيف api_password تلقائيًا، تقدر تشيل السطر ده
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return res.data; // غالبًا: { reviews: [...] }
};